<template>
	<div v-if="isLoggedIn" class="notification-drawer" id="notification-drawer" :key="'notification_' + notificationUpdate">
		<v-btn @click.stop="openNotifications" icon size="large" style="position: absolute; top: 6px; right: 55px">
			<v-badge v-if="notificationCount > 0" :content="notificationCount" color="red" overlap :key="'badge_' + notificationUpdate">
				<v-icon color="primary" size="27">mdi-bell</v-icon>
			</v-badge>
			<v-icon v-else color="primary" size="27">mdi-bell</v-icon>
		</v-btn>
		<v-navigation-drawer width="300" temporary location="right" v-model="showNotifications" style="z-index: 1020">
			<template v-slot:prepend>
				<div class="notification-drawer-header">
					<span>{{ $t('notification.title') }}</span>
					<v-select
						v-model="filter"
						:items="getFilters"
						item-title="name"
						item-value="value"
						@update:modelValue="getNotifications"
						:menu-props="{ contentClass: 'notification-filter' }"
						variant="underlined"
						density="compact"
						hide-details
						color="primary"
					></v-select>
				</div>
			</template>

			<v-divider></v-divider>

			<v-virtual-scroll id="v-scroll" :bench="3" :items="finalNotifications" :height="notificationHeight" item-height="120">
				<template v-slot:default="{ item }">
					<notification-item
						:id="'notification-' + item._id"
						:notification="item"
						:bg="true"
						:clickable="true"
						:useRead="true"
						:active="showNotifications"
						@intersect="onNotificationIntersect"
						@closeNotifications="closeNotifications"
					></notification-item>
				</template>
			</v-virtual-scroll>
		</v-navigation-drawer>
	</div>
</template>

<script>
import { DateTime } from 'luxon';
import { mapState, mapActions, mapGetters } from 'vuex';
import NotificationItem from '../modules/solution/components/NotificationItem.vue';

export default {
	components: { NotificationItem },
	data() {
		return {
			filter: 'all',
			showNotifications: false,
			newReadNotification: [],
			notificationHeight: 0,
			notificationScrollPosition: 0,
			finalNotifications: [],
		};
	},
	computed: {
		...mapState({
			user: (state) => state.auth.user,
			notification: (state) => state.notification.notification,
			notificationUpdate: (state) => state.notification.notificationUpdate,
			users: (state) => state.users.users,
		}),
		...mapGetters({ isLoggedIn: 'auth/isLoggedIn' }),
		getFilters() {
			let filters = [];

			filters.push({ name: this.$t('notification.filter_new'), value: 'new' });
			filters.push({ name: this.$t('notification.filter_action'), value: 'action' });
			filters.push({ name: this.$t('notification.filter_done'), value: 'done' });
			filters.push({ name: this.$t('notification.filter_info'), value: 'info' });
			filters.push({ name: this.$t('notification.filter_read'), value: 'read' });
			filters.push({ name: this.$t('notification.filter_all'), value: 'all' });
			filters.push({ name: this.$t('notification.filter_ignored'), value: 'ignored' });

			/*for (const key in this.category) {
				let cat = this.category[key];
				filters.push({ name: this.$t(cat.label), value: key });
			}*/

			return filters;
		},
		notificationCount() {
			if (this.notification && this.notification[0]) {
				const actionNotifications = this.notification[0].filter((notification) => {
					let state1 = notification.action && !this.isDone(notification) && !this.isIgnored(notification);
					let state2 = !notification.action && !this.isRead(notification) && !this.isIgnored(notification);

					return state1 || state2;
				});
				return actionNotifications.length;
			} else {
				return 0;
			}
		},
	},
	methods: {
		...mapActions({
			load: 'users/load',
			markNotifiactionAsRead: 'notification/markNotifiactionAsRead',
		}),
		getNotifications() {
			let finalNotifications = [];
			for (let keyPrio in this.notification) {
				for (let keyNotify in this.notification[keyPrio]) {
					let notification = this.notification[keyPrio][keyNotify];

					let created = DateTime.fromISO(notification.createdAt);
					let now = DateTime.now();
					let diff = now.diff(created, ['hours']);

					//Remove all notifications which are older than 24 hours (except those which actions are needed)
					if (diff.hours > 24 && notification.action && this.isDone(notification)) {
						continue;
					}

					if (this.notificationShow(notification)) {
						finalNotifications.push(notification);
					}
				}
			}

			//Jump back to current scroll position
			// eslint-disable-next-line
			this.$nextTick(() => {
				document.getElementById('v-scroll').scrollTop = this.notificationScrollPosition;
			});
			finalNotifications.sort((n1, n2) => {
				// Show all unread or not done notifications first
				const n1IsPending = !this.isRead(n1) || (n1.action && !this.isDone(n1));
				const n2IsPending = !this.isRead(n2) || (n2.action && !this.isDone(n2));

				if (n1IsPending != n2IsPending) {
					return n1IsPending ? -1 : 1;
				}

				// Sort by createdAt (newest first)
				const n1CreatedAt = DateTime.fromISO(n1.createdAt);
				const n2CreatedAt = DateTime.fromISO(n2.createdAt);
				return n2CreatedAt - n1CreatedAt; // Newest notifications first
			});

			this.finalNotifications = finalNotifications;
		},
		notificationShow(notification) {
			let result = false;

			if (this.filter == 'all') {
				result = true;
			}

			if (this.filter == notification.category) {
				result = true;
			}

			if (this.filter == 'action' && notification.action && !this.isDone(notification) && !this.isIgnored(notification)) {
				result = true;
			}

			if (this.filter == 'done' && this.isDone(notification)) {
				result = true;
			}

			if (this.filter === 'ignored' && this.isIgnored(notification) && !this.isDone(notification)) {
				result = true;
			}

			let readSince = 0;
			if (notification.read) {
				let read = DateTime.fromISO(notification?.read[this.user.id]);
				let now = DateTime.now();
				readSince = now.diff(read, ['hours']);
			}

			const state1 = notification.action && !this.isDone(notification);
			const state2 = !notification.action && !this.isRead(notification);
			const state3 = !notification.action && readSince < 24;
			if (this.filter == 'new' && (state1 || state2 || state3)) {
				result = true;
			}

			if (this.filter == 'info' && !notification.action) {
				result = true;
			}

			if (this.filter == 'read' && this.isRead(notification)) {
				result = true;
			}

			/*if (this.isDone(notification) || !notification.action) {
				let created = DateTime.fromISO(notification.createdAt);
				let now = DateTime.now();
				let diff = now.diff(created, ['hours']);

				if (diff.hours > 24) {
					result = false;
				}
			}*/

			return result;
		},
		isIgnored(notification) {
			if (notification.ignored) {
				if (Object.keys(notification.ignored).length > 0) {
					return true;
				}
			}

			return false;
		},
		isDone(notification) {
			let result = false;
			if (notification.done) {
				if (Object.keys(notification.done).length > 0) {
					result = true;
				}
			}

			return result;
		},
		isRead(notification) {
			let result = false;
			if (notification.read) {
				if (Object.keys(notification.read).length > 0) {
					if (notification.read[this.user.id]) {
						result = true;
					}
				}
			}

			return result;
		},
		openNotifications() {
			this.getNotifications();
			this.showNotifications = true;
			this.$nextTick(() => {
				const element = document.getElementById('v-scroll');
				if (element) {
					this.notificationHeight = element.parentElement.offsetHeight - 10;
				}
			});
		},
		closeNotifications() {
			this.showNotifications = false;
		},
		markAsRead(notificationId) {
			for (let keyPrio in this.notification) {
				this.notification[keyPrio].forEach((n) => {
					if (n._id == notificationId && !this.isRead(n)) {
						this.markNotifiactionAsRead({ notificationId });
					}
				});
			}
		},

		onNotificationIntersect(notificationId) {
			if (this.showNotifications) {
				this.notificationScrollPosition = document.getElementById('v-scroll').scrollTop;
				this.markAsRead(notificationId);
			}
		},
		handleClick(e) {
			if (!this.showNotifications) return;

			const container = document.querySelector('.notification-drawer .v-navigation-drawer');
			const classList = Array.from(e.target.classList);
			if (classList.includes('v-badge__badge')) return;
			if (classList.includes('v-list-item-title')) return;
			const filterMenu = document.querySelector('.notification-filter');
			if (filterMenu && filterMenu.contains(e.target)) return;
			if (container && !container.contains(e.target)) {
				this.showNotifications = false;
			}
		},
	},
	beforeMount() {
		//Init Store
		if (this.user && this.user.permissions['users.read']) {
			this.load(this.showDeleted);
		}
	},
	mounted() {
		//Reset scroll position
		this.notificationScrollPosition = 0;
		window.addEventListener('click', this.handleClick);
	},
	beforeUnmount() {
		window.removeEventListener('click', this.handleClick);
	},
};
</script>

<style>
.notification-drawer {
	position: absolute;
	top: 0px;
	right: 30px;
	z-index: 1200;
}
.notification-drawer * {
	z-index: 15;
	font-size: 13px;
}

.notification-drawer .v-navigation-drawer {
	/* background-color: var(--v-grey-100-base) !important; */
}

.notification-drawer-header {
	display: flex;
	justify-content: space-between;
	align-items: center;
	height: 64px;
	padding: 8px;
}

.notification-drawer-header .v-select {
	max-width: 40%;
	font-weight: bold;
}

.notification-drawer-header .v-select .v-text-field__details {
	display: none !important;
}

.notification-drawer-header .v-select .v-select__menu-icon {
	font-size: 22px !important;
	color: rgb(var(--v-theme-primary)) !important;
	opacity: 1 !important;
}

.notification-drawer-items {
	padding: 8px;
}

.notification-drawer-items-title {
	font-size: 14px;
	padding: 0px 5px;
	text-transform: uppercase;
}

.notification-filter {
	z-index: 16;
}

.v-virtual-scroll,
.v-navigation-drawer__prepend {
	background-color: #fff;
}

.v-navigation-drawer__prepend {
	margin-top: 28px;
}
</style>
